import MenuPosition from 'models/application/menu/position/Position';

export default class LinkMenuPosition extends MenuPosition {}
